import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { addParticularCompany, addUser, addUserCompanyAccess, removeUser } from "../utils/userSlice";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../utils/loaderSlice";
import LoginForm from "./Onboarding/components/LoginForm";
import { WelcomeSection } from "./Onboarding/components/WelcomeSection";
import { FETCH_USER_PROFILE, LOGIN_URL, REFRESH_TOKEN_URL } from "../utils/constants";
import { useLazyFetchCompanyPermissionsQuery } from "../utils/customer/customerTable";
import { applyThemeColors } from "./Header";
import { getUserId, getUserToken } from "../utils/utilityFunctions/localServices";

const Login = () => {
  const [isSwtiching, setIsSwitching] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state, search } = useLocation();

  useEffect(() => {
    // dispatch(hideLoader());
    // navigate("/onboarding/login");
  }, []);

  const query = new URLSearchParams(search);
  const switchCode = query.get("swc");

  //company permission api
  const [fetchCompanyPermissions, { data: companyPermissionsData, isSuccess: companyPermissionsSuccess }] =
    useLazyFetchCompanyPermissionsQuery();

  const updateAndNagivate = async () => {
    dispatch(addUserCompanyAccess(companyPermissionsData?.data));
    localStorage.setItem("company_preference", JSON.stringify(companyPermissionsData?.data?.preferences));
    localStorage.setItem("userPreferences", JSON.stringify(companyPermissionsData?.data?.user_preferences));
    applyThemeColors(companyPermissionsData?.data?.user_preferences?.theme_color);
    navigate("/customers");
  };

  const processUserData = (data) => {
    dispatch(
      addParticularCompany({
        company_id: data?.company?.id,
        company_name: data?.company?.company_name,
        company_logo: data?.company?.company_logo,
        menuName: "",
      })
    );

    if (data?.user_id !== getUserId()) localStorage.removeItem("saved_view");

    dispatch(addUser(data));
    localStorage.setItem("ownerInfo", JSON.stringify({ isOwner: Boolean(data?.super_admin) }));

    // if (data?.workspaces && data?.workspaces.length > 1) {
    //   navigate("/organisations", { state: { workspaces: data?.workspaces } });
    // } else {
    fetchCompanyPermissions({ token: getUserToken(), companyId: data?.company?.id });
    // }
  };

  useEffect(() => {
    if (companyPermissionsData && companyPermissionsData?.data) updateAndNagivate();
  }, [companyPermissionsData, companyPermissionsSuccess]);

  const handleSwitch = async (switchCode) => {
    if (isSwtiching) return;

    setIsSwitching(true);

    const payload = { refresh_token: switchCode };

    try {
      const response = await fetch(REFRESH_TOKEN_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const res = await response.json();

      if (!res.success || !res?.data?.access_token) {
        navigate("/onboarding/login");
      }

      const userResponse = await fetch(`${FETCH_USER_PROFILE}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${res?.data?.access_token}`, // 👈 attach your token here
        },
      });

      const userRes = await userResponse.json();
      console.log("Switch Account Response:", userRes);

      const data = userRes?.data;
      // if (formData?.rememberMe) localStorage.setItem("userInfo", JSON.stringify({ keepLoggedIn: true }));
      processUserData({ ...data, token: res.data.access_token, refresh_token: res.data.refresh_token });
    } catch (error) {
      console.error("Login Error:", error);
      navigate("/");
      // setErrorMessage("Something went wrong. Please try again later.");
    }
  };

  useEffect(() => {
    if (switchCode && !isSwtiching) {
      dispatch(showLoader());
      handleSwitch(switchCode);
    } else dispatch(hideLoader());
  }, [switchCode]);

  return (
    <div className="flex overflow-hidden relative w-full h-full bg-secondary max-md:flex-col max-md:h-auto">
      <WelcomeSection />
      {isSwtiching ? (
        <div className="min-h-screen w-1/2 flex items-center justify-center text-primary px-4 font-Inter font-bold text-2xl">
          Please Wait
          <br /> Switching to CRM...
        </div>
      ) : (
        <LoginForm />
      )}
    </div>
  );
};

export default Login;
